import { PropsWithChildren, ReactNode } from "react";
import { textAlignClassName, textColorClassName, textFontClassName } from "./commonClassNames";
import { TextAlignProp } from "./commonProps";

export type FieldProps = TextAlignProp & {
  label: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
  className?: string;
};

export const Field: React.FC<PropsWithChildren<FieldProps>> = ({
  children,
  label,
  textAlign,
  labelClassName,
  valueClassName,
  className,
}) => {
  const lineHeight = 6;
  const size = "sm";

  const combinedLabelClassName = [
    "font-poppins text-sm whitespace-nowrap text-neutral-300",
    textAlignClassName({ textAlign }),
    textFontClassName({ lineHeight, size }),
    labelClassName ?? "",
  ].join(" ");

  const combinedValueClassName = [
    "whitespace-nowrap",
    textColorClassName({ accent: true }),
    textAlignClassName({ textAlign }),
    textFontClassName({ font: "semibold", lineHeight, size }),
    valueClassName ?? "",
  ].join(" ");

  return (
    <div className={className}>
      <div className={combinedLabelClassName}>{label}</div>
      <div className={combinedValueClassName}>{children}</div>
    </div>
  );
};
